"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PassengersSeatsOnFlights = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const ageType_1 = require("../../../utils/ageType");
const classFunctions_1 = require("../../../utils/classFunctions");
const Button_1 = require("../../Button");
const Sub_1 = require("../../Page/Title/Sub");
const Item_1 = require("./Item");
require("./index.scss");
const className = 'passengers-seat-on-flights';
const PassengerSeatsRow = (props) => {
    const { passengerSeats, resetSeat, openSeatsSelectionPopup } = props;
    return (react_1.default.createElement("div", { className: `${className}__row` },
        react_1.default.createElement("div", { className: `${className}__passenger` },
            react_1.default.createElement("p", null,
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/PassengersSeatsOnFlights:Passenger', defaultMessage: 'Passenger' }),
                ` ${passengerSeats.id + 1}`,
                passengerSeats.ageType ? ', ' : '',
                (0, ageType_1.translateAgeType)(passengerSeats.ageType)),
            react_1.default.createElement("h3", null, passengerSeats.passengerNameText)),
        react_1.default.createElement("div", { className: `${className}__seat` },
            react_1.default.createElement(Item_1.SeatItem, { ...passengerSeats.outbound, resetSeat: () => resetSeat(passengerSeats.id, 'outbound'), openSeatSelectionPopup: () => {
                    openSeatsSelectionPopup({
                        flightDirection: 'outbound',
                        tariffGroupCode: passengerSeats.outbound.tariffGroupCode,
                        selectedPassengerId: passengerSeats.id,
                    });
                } })),
        passengerSeats.return && (react_1.default.createElement("div", { className: `${className}__seat` },
            react_1.default.createElement(Item_1.SeatItem, { ...passengerSeats.return, resetSeat: () => resetSeat(passengerSeats.id, 'return'), openSeatSelectionPopup: () => {
                    var _a;
                    openSeatsSelectionPopup({
                        flightDirection: 'return',
                        tariffGroupCode: (_a = passengerSeats.return) === null || _a === void 0 ? void 0 : _a.tariffGroupCode,
                        selectedPassengerId: passengerSeats.id,
                    });
                } })))));
};
const PassengersSeatsOnFlights = (props) => {
    const { resetSeat, seatsByPassenger, openSeatsSelectionPopup, totalPrice, modificators, submitHidden, submitDisabled, submit, } = props;
    const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("div", { className: `${className}__container` },
            react_1.default.createElement(Sub_1.PageSubTitle, { icon: 'seat', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/PassengersSeatsOnFlights:Title', defaultMessage: 'Seat reservation' }) }),
            react_1.default.createElement("div", { className: `${className}__rows` }, seatsByPassenger.map((passengerSeats, idx) => (react_1.default.createElement(PassengerSeatsRow, { key: `rpsof::${idx}::passenger::${passengerSeats.id}`, passengerSeats: passengerSeats, resetSeat: resetSeat, openSeatsSelectionPopup: openSeatsSelectionPopup })))),
            totalPrice && (react_1.default.createElement("div", { className: `${className}__total` },
                react_1.default.createElement("div", { className: `${className}__total-label` },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/PassengersSeatsOnFlights:SeatsTotalPrice', defaultMessage: 'Seat(s) price' })),
                react_1.default.createElement("div", { className: `${className}__total-price` },
                    "CHF ",
                    totalPrice)))),
        !submitHidden && (react_1.default.createElement("div", { className: `${className}__button` },
            react_1.default.createElement(Button_1.Button, { disabled: submitDisabled, onClick: submit, text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/PassengersSeatsOnFlights:ConfirmationButton', defaultMessage: 'Confirm seat selection' }) })))));
};
exports.PassengersSeatsOnFlights = PassengersSeatsOnFlights;
//# sourceMappingURL=index.js.map